import React, { useEffect, useState } from "react";
import { api, fmtNum } from "@finance/lib/api";
import { exportToCsv } from "@finance/lib/exportCsv";
import Layout, { PageHeader } from "@finance/components/Layout";
import { Button } from "@finance/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@finance/components/ui/tabs";

const DEF = {
  pending_efd: [["xp_no", "No"], ["description", "Description"], ["supplier_name", "Supplier"], ["age_days", "Age (days)"], ["bucket", "Bucket"], ["amount", "Open advance (TZS)"]],
  non_deductible: [["xp_no", "No"], ["description", "Description"], ["supplier_name", "Supplier"], ["reason", "Tag"], ["amount", "Amount (TZS)"]],
  staff_allowance: [["xp_no", "No"], ["employee", "Employee"], ["advanced", "Advanced (TZS)"], ["efd", "EFDs (TZS)"], ["open", "Open (TZS)"], ["payroll", "Pushed to payroll"]],
};

function T({ k, rows }) {
  const cols = DEF[k].map(([key, label]) => ({ key, label }));
  return (
    <div>
      <div className="mb-2 flex justify-end"><Button size="sm" variant="outline" data-testid={`xpr-export-${k}`} onClick={() => exportToCsv(`expense-report-${k}`, rows, cols)}>Export CSV</Button></div>
      <div className="overflow-x-auto rounded-sm border border-gray-200 bg-white">
        <table className="w-full text-sm" data-testid={`xpr-table-${k}`}>
          <thead className="bg-gray-50"><tr className="lx-label border-b text-gray-400">{cols.map((c) => <th key={c.key} className="px-3 py-2 text-left">{c.label}</th>)}</tr></thead>
          <tbody>{rows.length === 0 ? <tr><td colSpan={cols.length} className="px-3 py-6 text-center text-xs text-gray-400">Nothing to show</td></tr> : rows.map((r, i) => (
            <tr key={i} className="border-b border-gray-50">{cols.map((c) => <td key={c.key} className="px-3 py-2">{typeof r[c.key] === "number" && c.key !== "age_days" ? fmtNum(r[c.key]) : String(r[c.key] ?? "\u2014")}</td>)}</tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}

export default function ExpenseReports() {
  const [d, setD] = useState({ pending_efd: [], non_deductible: [], staff_allowance: [], aging: {} });
  useEffect(() => { api.get("/xp/reports").then((r) => setD(r.data)); }, []);
  return (
    <Layout>
      <PageHeader title="Expense Reports" subtitle="Pending EFD aging, non-deductible add-backs and the staff allowance ledger (TZS)." />
      <div className="p-4 md:p-8" data-testid="xpr-page">
        <div className="mb-4 grid grid-cols-3 gap-3">{["0-30", "31-60", "60+"].map((b) => <div key={b} className="rounded-sm border border-gray-200 bg-white p-3" data-testid={`xpr-aging-${b}`}><div className="text-xs text-gray-500">Pending EFD {b} days</div><div className="font-display text-xl font-bold lx-num">TZS {fmtNum(d.aging?.[b] || 0)}</div></div>)}</div>
        <Tabs defaultValue="pending_efd">
          <TabsList><TabsTrigger value="pending_efd" data-testid="xpr-tab-pending">Pending EFD</TabsTrigger><TabsTrigger value="non_deductible" data-testid="xpr-tab-nond">Non-deductible</TabsTrigger><TabsTrigger value="staff_allowance" data-testid="xpr-tab-staff">Staff Allowance ledger</TabsTrigger></TabsList>
          {Object.keys(DEF).map((k) => <TabsContent key={k} value={k} className="mt-4"><T k={k} rows={d[k] || []} /></TabsContent>)}
        </Tabs>
      </div>
    </Layout>
  );
}
